import { Modal, Row, Col, Select, DatePicker, Button, Spin, Table, message } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { EditOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import { Space, Popconfirm } from "antd";
import { addScheduleData, deleteScheduleData, getScheduleData, updateScheduleData } from "../../redux/actions/schedule.action";
const { Option } = Select;

const ScheduleModal = ({ token, open, data, onClose, onGenerate }) => {
  const [scheduleType, setScheduleType] = useState("Daily");
  const [category, setCategory] = useState("Men");
  const [status, setStatus] = useState(true);
  const [time, setTime] = useState(null);
  const [loading, setLoading] = useState(false);
  const [uiFilters, setUiFilters] = useState({});
  const [dataScheduledList, setDataScheduledList] = useState([]);
  const [editRecord, setEditRecord] = useState(null);
  const [editingRowId, setEditingRowId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (open) {
      // reset all fields to initial
      setScheduleType("Daily");
      setCategory("Men");
      setStatus(true);
      setTime(null);
      setUiFilters(data?.uiData || {});
      setEditRecord(null);
      setEditingRowId(null);

      // fetch scheduled data from API
      if (token && data?.report_id) {
        setLoading(true);
        dispatch(getScheduleData(token, data?.report_id))
          .then((res) => {
            setDataScheduledList(res?.payload?.data || []);
            setLoading(false);
          })
          .catch((err) => {
            console.error(err);
            setLoading(false);
          });
      }
    }
  }, [open, token, data?.report_id, data?.uiData, dispatch]);

  useEffect(() => {
    if (data?.uiData) {
      setUiFilters(data.uiData);
    }
  }, [data]);

  if (!data.uiData) return null;
  const entries = Object.entries(uiFilters || {});




  const handleGenerate = () => {
    const apiPayload = {
      report_filters: data.report_filters,
      report_ui_filters: data.uiData,
      report_columns: data.report_columns,
      report_id: data.report_id,
      report_name: data.report_name,
      api_route: data.api_route,
      report_type: data.type,
      email_dates: data.emailDates,
      start_date: time,
      schedule: scheduleType,
      is_active: status,
      gender: category,
    };
    setLoading(true);
    dispatch(addScheduleData(token, apiPayload))
      .then((res) => {
        return dispatch(getScheduleData(token, data?.report_id));
      })
      .then((res) => {
        setDataScheduledList(res?.payload?.data || []);
        setScheduleType("Daily");
        setCategory("Men");
        setStatus(true);
        setTime(null);
        setLoading(false);
        // onClose(); // close modal if needed
      })
      .catch((err) => {
        console.error("API error:", err);
        setLoading(false);
      });
  };

  console.log("dataScheduledList", dataScheduledList)

  const handleEdit = (record) => {
    console.log("record.report_ui_filters", record.report_ui_filters)
    setEditRecord(record);
    setScheduleType(record.schedule);
    setCategory(record.gender);
    setStatus(record.is_active);
    setTime(record.start_date);

    if (record.report_ui_filters) setUiFilters(record.report_ui_filters);

    setEditingRowId(record.routine_id); // mark this row as editing
  };
  const handleUpdate = () => {
    console.log("editRecord", editRecord)
    const apiPayload = {
      schedule: scheduleType,
      gender: category,
      is_active: status,
      start_date: time
    };

    setLoading(true);

    dispatch(updateScheduleData(token, editRecord?.routine_id, apiPayload))
      .then(() => {
        return dispatch(getScheduleData(token, data?.report_id));
      })
      .then((res) => {
        setDataScheduledList(res?.payload?.data || []);
        setLoading(false);
        setScheduleType("Daily");
        setCategory("Men");
        setStatus(true);
        setTime(null);
        setEditRecord(null); // reset edit mode
      })
      .catch((err) => {
        console.error("Update error:", err);
        setLoading(false);
      });
  };


  const handleDelete = (record) => {

    dispatch(deleteScheduleData(token, record))
      .then(() => {
        return dispatch(getScheduleData(token, data?.report_id));
      })
      .then((res) => {
        setDataScheduledList(res?.payload?.data || []);
      })
      .catch((err) => {
        console.error("Delete error:", err);
      });
  };


  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      key: 'index',
      width: 40,
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Schedule Type',
      dataIndex: 'schedule',
      key: 'schedule',
    },
    {
      title: 'Category',
      dataIndex: 'gender',
      key: 'gender',
    },
    {
      title: 'Schedule Time',
      dataIndex: 'start_date',
      key: 'start_date',
      render: (text) => text ? moment(text).format("YYYY-MM-DD HH:mm") : "-"
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (isActive) => (
        <span style={{ color: isActive ? 'green' : 'red', fontWeight: 500 }}>
          {isActive ? 'Active' : 'InActive'}
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          {editingRowId === record.routine_id ? (
            <CloseOutlined
              style={{ color: "red", cursor: "pointer" }}
              onClick={() => {
                setEditRecord(null);
                setScheduleType("Daily");
                setCategory("Men");
                setStatus(true);
                setTime(null);
                setUiFilters(data.uiData);
                setEditingRowId(null);
              }}
            />
          ) : (
            <EditOutlined
              style={{ color: "#1890ff", cursor: "pointer" }}
              onClick={() => handleEdit(record)}
            />
          )}

          <Popconfirm
            title="Are you sure delete this schedule?"
            onConfirm={() => handleDelete(record?.routine_id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined
              style={{ color: "red", cursor: "pointer" }}
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleGenerateOrUpdate = () => {
    if (!scheduleType) return message.error("Schedule Type is required");
    if (!category) return message.error("Category is required");
    if (!time) return message.error("Date & Time is required");

    editRecord ? handleUpdate() : handleGenerate();
  };



  return (
    <Modal
      className="testmodal"
      visible={open}
      onCancel={onClose}
      footer={null}
      title="Schedule Data"
      width={900}
    >
      <div style={{ maxHeight: 300, overflowY: "auto", marginBottom: 16 }}>
        {dataScheduledList ? (
          <Table
            dataSource={dataScheduledList}
            columns={columns}
            rowKey={(record) => record?.routine_id}
            pagination={{ pageSize: 10 }}
            size="small"
            locale={{ emptyText: "No Schedule Found" }}
          />
        ) : (
          <Spin tip="Loading schedule data..." />
        )}
      </div>

      {/* Filters */}
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <label>Schedule Type</label>
          <Select
            value={scheduleType}
            onChange={(val) => setScheduleType(val)}
            className="w-100"
          >
            <Option value="Daily">Daily</Option>
            <Option value="Alternate">Alternate</Option>
            <Option value="Weekly">Weekly</Option>
            <Option value="Monthly">Monthly</Option>
          </Select>
        </Col>
        <Col span={6}>
          <label>Category</label>
          <Select
            value={category}
            onChange={(val) => setCategory(val)}
            className="w-100"
          >
            <Option value="Men">Men</Option>
            <Option value="Women">Women</Option>
            <Option value="Kids">Kids</Option>
          </Select>
        </Col>
        <Col span={6}>
          <label>Status</label>
          <Select
            value={status}
            onChange={(val) => setStatus(val)}
            className="w-100"
          >
            <Option value={true}>Active</Option>
            <Option value={false}>InActive</Option>
          </Select>
        </Col>
        <Col span={6}>
          <label>Date & Time</label>
          <DatePicker
            value={time ? moment(time) : null}
            onChange={(val, dateString) => setTime(dateString)}
            showTime={{ format: "HH:mm" }}
            format="YYYY-MM-DD HH:mm"
            className="w-100"
            placeholder="Select date & time"
            disabledDate={(current) =>
              current && current < moment().startOf("day")
            }
            disabledTime={(current) => {
              if (!current) return {};

              const now = moment();

              // agar selected date aaj hai
              if (current.isSame(now, "day")) {
                return {
                  disabledHours: () =>
                    Array.from({ length: now.hour() }, (_, i) => i),

                  disabledMinutes: (selectedHour) => {
                    if (selectedHour === now.hour()) {
                      return Array.from({ length: now.minute() }, (_, i) => i);
                    }
                    return [];
                  },
                };
              }

              return {};
            }}
          />
        </Col>
      </Row>

      {/* Schedule Data Table */}
      <div style={{ maxHeight: "400px", overflowY: "auto", marginBottom: "16px" }}>
        {entries.map(([label, value], index) => (
          <Row
            key={index}
            style={{
              padding: "8px 0",
              borderBottom: "1px solid #f0f0f0",
              display: "flex",
            }}
          >
            <Col span={10} style={{ fontWeight: 600 }}>
              {label}:
            </Col>
            <Col span={14} style={{ wordBreak: "break-word" }}>
              {Array.isArray(value)
                ? value.join(", ")
                : value !== null && value !== undefined
                  ? value
                  : "All"}
            </Col>
          </Row>
        ))}
      </div>

      {/* Generate Button */}
      <div style={{ marginTop: 20, textAlign: "right" }}>
        <Button
          type="primary"
          onClick={handleGenerateOrUpdate}
          loading={loading}
        >
          {editRecord ? "Update" : "Generate"}
        </Button>
      </div>
    </Modal>
  );
};

export default ScheduleModal;